// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-hMq","col":"styles_col__2SmHl","actions":"styles_actions__3uE6q","conflict":"styles_conflict__w4gOw"};